<template>
  <!-- There are bugs on iOS with simply assigning 'overflow-hidden' to this outer class, hence the additional use of clip-path. Note that clip-path itself wasn't enough to cover your old version of desktop Safari. -->
  <div
    v-if="mask"
    class="absolute overflow-hidden"
    style="clip-path: content-box;"
    v-bind:style="{ ...blobMaskTransform, 'mask-image': mask.img }"
  >
    <div v-if="transformInProgress" class="absolute-fill template-editable" />
    <div class="absolute" v-bind:style="blobMaskRelativeTransform">
      <slot></slot>
    </div>
    <!-- Content positioned relative to the mask itself rather than to the (independently transformed) blob in it -->
    <slot name="overlay"></slot>
  </div>
  <div v-else class="absolute" v-bind:style="blobTransform">
    <slot></slot>
  </div>
</template>


<style scoped>
.template-editable {
  box-sizing: border-box;
  border: 1px dashed rgb(25, 118, 210);
  transition: background-color .2s;
}
.template-editable {
  background-color: rgb(25, 118, 210, .08);
}
</style>


<script>
export default {
  name: 'blob-mask',
  props: [ 'mask', 'blobTransform', 'blobMaskTransform', 'blobMaskRelativeTransform', 'transformInProgress' ]
}
</script>
